import { library } from '@fortawesome/fontawesome-svg-core'
import { faFile, faUpload, faFileImport, faAngleUp, faChartBar } from '@fortawesome/free-solid-svg-icons'
library.add(faFile, faUpload, faFileImport, faAngleUp, faChartBar)
